<div #barsgraph class="barsgraph" (waResizeObserver)="setViewBoxSizes()">
  <div class="graph_buttons">
    <div (click)="zoom('out')" class="icon zoomout"></div>
    <div (click)="zoom('in')" class="icon zoomin"></div>

  </div>
  @if (position > 0) {
    <div class="graph-controls prev">
      <div (click)="previous()" class="icon"></div>
    </div>
  }
  @if (position < list.length - showNumber) {
    <div class="graph-controls next">
      <div (click)="next()" class="icon"></div>
    </div>
  }


  @if (graphRefHeight) {
    <svg   width="100%" height="100%" [attr.viewBox]="viewBoxSize">
      <g class="bars" >
        <g class="table">
          @for (line of range; track line; let i = $index) {
            <g >
              <line class="guide" x1="32" [attr.y1]="10 + (separatorIndex * i)" [attr.x2]="viewBoxwidth - 24" [attr.y2]="10 + (separatorIndex * i)"></line>
              <g>
                @switch (dataType) {
                  @case ('percent') {
                    <text class="guide yAxis" x="30" [attr.y]="15 + (separatorIndex * i)">
                      {{100 - (100 / 10 * i)}}%
                    </text>
                  }
                  @case ('minutes') {
                    <text class="guide yAxis" x="30" [attr.y]="15 + (separatorIndex * i)">
                      {{(max - ( max / 10 * i)) / 60 | number:'1.0-0'}}
                    </text>
                  }
                  @default {
                    <text class="guide yAxis" x="30" [attr.y]="15 + (separatorIndex * i)">
                      {{max - ( max / 10 * i) | number:'1.0-1'}}
                    </text>
                  }
                }
              </g>
            </g>
          }
          <line class="axys" x1="35" y1="10" x2="35" [attr.y2]="graphRefHeight - 20" />
          <text class="guide AxisLabel" x="-12" y="47" transform="rotate(-90)" >{{ylabel | translate}}</text>
          @if (showAverage) {
            <ng-container>
              @for (graph of yObjects; track graph) {
                <line
                  class="average" [ngClass]="graph.type" x1="38" [attr.y1]="getAverageHeight(graph)" [attr.x2]="viewBoxwidth - 21" [attr.y2]="getAverageHeight(graph)" />
              }
            </ng-container>
          }
          @for (item of list | slice:position:showNumber+position ; track item; let i = $index) {
            <g [ngClass]="{'rotate-label': rotateLabelsX}">
              <line class="guide" [attr.x1]="labelPosition(i)" y1="10" [attr.x2]="labelPosition(i)" [attr.y2]="graphRefHeight - 17"></line>
              <text
                class="guide xAxis pointer"
                [tooltip]="getXLabel(item, true)"
                [placement]="'top'"
                [attr.transform]="getXLabelRotation(i)"
                [attr.x]="labelPosition(i)"
                [attr.y]="graphRefHeight - 8">
                {{getXLabel(item)}}
              </text>
              @for (graph of yObjects; track graph; let yOb = $index) {
                <g class="bar">
                  <rect
                    [attr.width]="getBarWidth()"
                    [attr.height]="getBarheight(item, graph)"
                    [attr.x]="getBarX(i, yOb)"
                    [attr.y]="item['posY_'+graph.type]"
                    fill="rgb(230,230,230)"
                    [ngClass]="graph.type"
                    (mouseenter)="setCursor($event, (getBarX(i, yOb) + getBarWidth()/2 - 25), item[graph.value])"
                    (mouseleave)="setCursor($event, 0 , null)">
                  </rect>
                </g>
              }
            </g>
          }
          @if (tooltipValue) {
            <g class="tool" [attr.transform]="'translate(' + tooltipPoistion + ', ' + cursorPoistion + ')'">
              <path class="tooltip" d="M 0 0 H 50 V 20 H 28 L 25 25 L 22 20 H 0 Z "></path>
              @if (dataTypeY) {
                <g>
                  @switch (dataTypeY) {
                    @case ('percent') {
                      <text x="25" y=14 color="rgb(50,50,50)">{{tooltipValue | number: '1.0-2'}}%</text>
                    }
                    @default {
                      <text x="25" y=14 color="rgb(50,50,50)">{{tooltipValue}}</text>
                    }
                  }
                </g>
              }
              @if (!dataTypeY) {
                <g>
                  @switch (dataType) {
                    @case ('minutes') {
                      <text x="25" y=14 color="rgb(50,50,50)" >{{getMinutes(tooltipValue)}}</text>
                    }
                    @default {
                      <text x="25" y=14 color="rgb(50,50,50)">{{tooltipValue}}</text>
                    }
                  }
                </g>
              }
            </g>
          }
          <line class="axys" x1="35" [attr.y1]="graphRefHeight - 20" [attr.x2]="viewBoxwidth - 24" [attr.y2]="graphRefHeight - 20" />
          <text class="guide AxisLabel" [attr.x]="viewBoxwidth - 24" [attr.y]="graphRefHeight - 22">{{xlabel | translate}}</text>
        </g>
      </g>
    </svg>
  }
</div>
